import { gql } from '@apollo/client';

export const CLOSE_KPI_CONFIG_MUTATION = gql`
  mutation CloseKpiConfig($id: Int!) {
    p {
      closeKpiConfig(id: $id) {
        success
        message {
          code
          message
        }
        content {
          id
          status
        }
      }
    }
  }
`;
